module.exports = __webpack_public_path__ + "img/lg_ring_g_c_0_0@3x.f90a08b3.png";